import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-360">
      {isOpen && <>
          {/* Overlay */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" data-id="element-361" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-362">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          type: 'spring',
          duration: 0.5
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-363">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-[#FFF9F5]" data-id="element-364">
                <h2 className="text-2xl font-serif font-bold text-gray-900" data-id="element-365">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 hover:bg-white rounded-full transition-colors text-gray-500 hover:text-gray-700" aria-label="Cerrar" data-id="element-366">
                  <X className="w-5 h-5" data-id="element-367" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(85vh-80px)]" data-id="element-368">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}